// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'

// Vue.use(VueAxios, axios)
import $store from '@/vuex/store.js'

// INCIA A FUNÇÃO PARA ENVIO DOS ARQUIVOS AO S3 E DEPOIS AVISAR A API QUE O PROCESSO TERINOU
export const ARMAZENAR_ARQUIVO_S3 = (files, refMod, refId, parcial = null) => {
  return new Promise((success, error) => {
    // INICIA A VARIAVEL PARA DAR O RETORNO
    var retornos = { result: { total: 0, transferido: 0, porcentagem: 0 } }
    
    // SETA A FUNÇÃO PARA ENVIAR O PROGRESSO DO PROCESSO
    const progress = function (mensagem, indexF, event = null) {
      if ([ '', null, undefined ].indexOf(parcial) === -1 && typeof parcial ===  'function') {
        // SETA A QUANTIDADE CONCLUIDA PARA ESTE ARQUIVO
        if ([ '', null, undefined ].indexOf(retornos[indexF]) === -1 && [ '', null, undefined ].indexOf(event) === -1 && [ '', null, undefined ].indexOf(event.loaded) === -1) {
          retornos[indexF].sizeEnviado = Number(event.loaded)
        }

        // REINICIA O CALCULO DO RESULTADO FINAL
        retornos.result = { total: 0, transferido: 0, porcentagem: 0 }

        // SOMA A TRANSFERENCIA DE TODOS OS ARQUIVOS
        for (indexF in retornos) {
          if ([ 'result' ].indexOf(indexF) === -1) {
            retornos.result.total += retornos[indexF].sizeTotal
            retornos.result.transferido += retornos[indexF].sizeEnviado
          }
        }

        // // SETA A PORCENTAGEM CONCLUIDA
        // retornos.result.porcentagem = Number((retornos.result.transferido / retornos.result.total) * 100).toFixed(2)
        
        // // ARREDONDA PARA 100% ENVIADO
        // if (retornos.result.porcentagem > 100) {
        //   retornos.result.porcentagem = 100
        // }

        // ENVIA OS DADOS PARCIAIS
        parcial(mensagem, retornos)
      }
    }

    // PASSA O STATUS DO PROCESSO
    progress('Iniciando processo.')

    // PASSA O STATUS DO PROCESSO
    progress('Validando requisição')

    // VALIDAÇÕES
    if ([ 7, 9, 10, 11, 12, 31, 53 ].indexOf(refMod) === -1) { // VERIFICA SE O MODULO RECEBIDO É VALIDO
      error({ loc: 'WEB', cod: 409, err: 'Módulo (' + refMod + ') informado para envio dos arquivos é inválido.' })
    } else if ([ '', null, undefined ].indexOf(refId) !== -1) { // VERIFICA SE É UM ID VALIDO PARA SALVAR
      error({ loc: 'WEB', cod: 409, err: 'Referência (' + refId + ') informado para envio dos arquivos é inválido.' })
    } else if ([ '', null, undefined ].indexOf(files) !== -1 || typeof files !== 'object' || [ '', null, undefined ].indexOf(files.length) !== -1 || files.length <= 0) { // VALIDA SE O VETOR DE ARQUIVOS É UM VETOR VALIDO
      error({ loc: 'WEB', cod: 409, err: 'O vetor de arquivos recebidos não é valido' })
    } else if (files.length >= 21) {
      error({ loc: 'WEB', cod: 409, err: 'Só é possivel enviar no maximo 20 arquivos por requisição' })
    } else {
      // INICIA A VARIAVEL
      for (var indexF in files) {
        if ([ '', null, undefined ].indexOf(files[indexF].type) === -1) {
          // SETA OS VALORES INICIAL
          retornos[indexF] = {
            chave: indexF,
            code: '',
            message: '',
            local: 'WEB',
            credencial: { request: {}, options: {} },
            sizeTotal: files[indexF].size,
            sizeEnviado: 0,
            porcentagem: 0,
            refApi: ''
          }
        }
      }


      // PASSA O STATUS DO PROCESSO
      progress('Iniciando validação dos arquivos')
      
      // CHAMA A FUNÇÃO PARA VALIDAR CADA ARQUIVO
      VALIDAR_ARQUIVOS(files, retornos, progress).then(() => {
        // PASSA O STATUS DO PROCESSO
        progress('Solicitando liberação para envio dos arquivos' )

        // SOLICITA A API AS CREDENCIAIS PARA ENVIAR OS ARQUIVOS
        SOLICITAR_CREDENCIAIS_API(files, refMod, refId, retornos).then(() => {
          // PASSA O STATUS DO PROCESSO
          progress('Iniciando envio dos arquivos' )

          // ENVIA O ARQUIVO PARA AMAZON
          ENVIAR_ARQUIVO_S3(files, retornos, progress).then((retornos) => {
            // PASSA O STATUS DO PROCESSO
            progress('Atualizando processo API Rotina Fácil.' )

            // ENVIA O ARQUIVO PARA AMAZON
            ATUALIZAR_ANDAMENTO_API_RF(retornos, progress).then(() => {
              // REMOVE A CHAVE RESULT
              delete retornos.result
              
              // FINALIZA O PROCESSO
              success(Object.values(retornos)) 
            }).catch(error)
          }).catch(error)
        }).catch(error)
      }).catch(error)
    }
  })
}

const VALIDAR_ARQUIVOS = (files, retornos, progress, indexF = 0, success = null, error = null) => {
  if (success === null && error === null) {
    return new Promise((success, error) => { VALIDAR_ARQUIVOS(files, retornos, progress, indexF, success, error) })
  } else if ([ '', null, undefined ].indexOf(retornos[indexF]) !== -1) {
    // PASSA O STATUS DO PROCESSO
    progress('Finalizando as validações dos arquivos.' )
    
    // FINALIZA O PROCESSO
    success()
  } else {
    // PASSA O STATUS DO PROCESSO
    progress('Validando os dados do arquivo (' + (indexF + 1) + ')' )
    
    // VERIFICA SE O ARQUIVO TEM UM NOME VALIDO
    if (retornos[indexF].code === '' && [ '', null, undefined ].indexOf(files[indexF].name) !== -1) {
      retornos[indexF].code = 400
      retornos[indexF].message = 'O nome do arquivo é inválido'
    }
  
    // VALIDA SE O TAMANHO DO ARQUIVO É VALIDO
    if (retornos[indexF].code === '' && ([ '', null, undefined ].indexOf(files[indexF].size) !== -1 || files[indexF].size <= 0)) {
      retornos[indexF].code = 400
      retornos[indexF].message = 'O tamanho do arquivo é inválido'
    }
    
    // VERIFICA SE EXISTE O TIPO DO ARQUIVO
    if (retornos[indexF].code === '' && ([ '', null, undefined ].indexOf(files[indexF].type) !== -1)) {
      retornos[indexF].code = 400
      retornos[indexF].message = 'O tipo do arquivo é inválido'
    }
  
    // VERIFICA O STATUS DO ARQUIVO
    switch (retornos[indexF].code === '') {
      case true:
        // PASSA O STATUS DO PROCESSO
        progress('O arquivo (' + (indexF + 1) + ') é validado')
  
        // REINICIA O PROCESSO PARA VERIFICAR OS OUTROS ARQUIVOS
        VALIDAR_ARQUIVOS(files, retornos, progress, (indexF + 1), success, error)
        break
  
      default:
        // PASSA O STATUS DO PROCESSO
        progress('O arquivo (' + (indexF + 1) + ') é inválido')
  
        // REINICIA O PROCESSO PARA VERIFICAR OS OUTROS ARQUIVOS
        VALIDAR_ARQUIVOS(files, retornos, progress, (indexF + 1), success, error)
        break
    }
  } 
}

const SOLICITAR_CREDENCIAIS_API = (files, refMod, refId, retornos, success = null, error = null) => {
  if (success === null && error === null) {
    return new Promise((success, error) => { SOLICITAR_CREDENCIAIS_API(files, refMod, refId, retornos, success, error) })
  } else {
    // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
    var formData = { lot: [] }

    // ADICIONA OS DADOS NO FORMULARIO
    for (var indexF in retornos) {
      if (retornos[indexF].code === '') {
        // INICIA OS DADOS DO ARQUIVO
        var file = { filename: files[indexF].name, chave: indexF }
    
        // SETA O MODULO QUE DEVE SALVAR ESTE ARQUIVO
        switch (refMod) {
          case 7:
            file.id_ema_mar_layout = refId
            break
          
          case 9:
            file.id_financeiro = refId
            break

          case 10:
            file.cod_venda = refId
            break
          
          case 11:
            file.dem_compra = refId
            break

          case 12:
            file.id_pro_imagem = refId
            break

          case 31:
            file.id_doc_fis_distribuir = refId
            break

          case 53:
            file.id_reg_atendimento = refId
            break
        }
    
        // ADICIONA O ARQUIVO NO VETOR
        formData.lot.push(file)
      }
    }

    if (formData.lot.length === 0) {
      success()
    } else {
      // FAZ A COMUNICAÇÃO COM A API
      $store.state.comunicaAPI('/arm-arquivo/credencial', 'POST', formData, function (apiSuccess) {
        for (var indexD in formData.lot) {
          // PEGA A CHAVE DO VETOR
          var indexF = formData.lot[indexD].chave
          
          // VERIFICA SE O RETORNO RECEBIDO FOI DE SUCESSO
          switch (apiSuccess.lot[indexD].code) {
            case '200':
              // SETA A CREDENCIAL RECEBIDA
              retornos[indexF].credencial = apiSuccess.lot[indexD].data

              // SETA A REFERENTENCIA API
              retornos[indexF].refApi = apiSuccess.lot[indexD].ref.id
              break
  
            default:
              // SETA O RETORNO RECEBIDO DA API
              retornos[indexF].code = apiSuccess.lot[indexD].code
              retornos[indexF].message = apiSuccess.lot[indexD].message
  
              // VERIFICA SE DEVE CONVERTE A MENSAGEM DE ARRAY PARA STRING
              if (typeof retornos[indexF].message === 'string') {
                retornos[indexF].message = retornos[indexF].message
              } else {
                retornos[indexF].message = [ '', null, undefined ].indexOf(retornos[indexF].message.length) === -1 ? retornos[indexF].message.join(' ') : Object.values(retornos[indexF].message).join(' ')
              }
              break
          }
        }
  
        // RETORNA O VALOR ATUALIZADO
        success()
      }, error)
    }
  }
}

const ENVIAR_ARQUIVO_S3 = (files, retornos, progress, indexF = 0, success = null, error = null) => {
  if (success === null && error === null) {
    return new Promise((success, error) => { ENVIAR_ARQUIVO_S3(files, retornos, progress, indexF, success, error) })
  } else if ([ '', null, undefined ].indexOf(files[indexF]) !== -1) {
    success(retornos)
  } else if (retornos[indexF].code !== '') {
    ENVIAR_ARQUIVO_S3(files, retornos, progress, (indexF + 1), success, error)
  } else {
    // PASSA O STATUS DO PROCESSO
    progress('Iniciando envio do arquivo (' + (indexF + 1) + ')')

    // INICIA O FORMULARIO QUE SERÁ ENVIADO
    var formData = new FormData()

    // ADICIONA OS DADOS RECEBIDOS AO FORMULARIO
    for (var indexC in retornos[indexF].credencial.formInputs) {
      formData.append(indexC, retornos[indexF].credencial.formInputs[indexC])
    }

    // ADICIONA O ARQUIVO
    formData.append('file', files[indexF])

    // INICIA A REQUISIÇÃO
    var request = { url: retornos[indexF].credencial.formAttributes.action, headers: { enctype: retornos[indexF].credencial.formAttributes.enctype } }

    // SETA O TIPO DE COMUNICAÇÃO
    request.method = retornos[indexF].credencial.formAttributes.method

    // ADICIONA O FORMULARIO A REQUISIÇÃO
    request.data = formData

    // PEGA A BILBIOTECA DEPENDENTE
    const axios = require('axios')

    // INICIA O LEITOR XML
    var leitorXML = new DOMParser()
    
    // SETA A FUNÇÃO PARA TRATAR O ENVIO DO ARQUIVO
    request.onUploadProgress = function (event) { progress('Realizando o upload do arquivo.', indexF, event) }

    // REALIZA A COMUNICAÇÃO COM A AMAZON
    axios(request).then(function () {
      // REINICIA O PROCESSO PARA ENVIAR OS OUTROS ARQUIVOS
      ENVIAR_ARQUIVO_S3(files, retornos, progress, (indexF + 1), success, error)
    }).catch(erro => {
      // FAZ A LEITURA DO RETORNO RECEBIDO
      var retorno = leitorXML.parseFromString(erro.response.data, 'text/xml')

      // SETA O ERRO RECEBIDO
      retornos[indexF].local = 'AWS'
      retornos[indexF].code = erro.response.status
      retornos[indexF].message = retorno.getElementsByTagName('Message')[0].childNodes[0].nodeValue

      // REINICIA O PROCESSO PARA ENVIAR OS OUTROS ARQUIVOS
      ENVIAR_ARQUIVO_S3(files, retornos, progress, (indexF + 1), success, error)
    })
  }
}

const ATUALIZAR_ANDAMENTO_API_RF = (retornos, progress, success = null, error = null) => {
  if (success === null && error === null) {
    return new Promise((success, error) => { ATUALIZAR_ANDAMENTO_API_RF(retornos, progress, success, error) })
  } else {
    // INICIA O FORMULARO QUE SERÁ ENVIADO PARA API
    var formData = { lot: [] }

    // SETA O STATUS 200 PARA TODOS QUE NÃO TEVE ERRO
    for (var indexD in retornos) {
      if (retornos[indexD].code === '') {
        formData.lot.push({ id: retornos[indexD].refApi, chave: indexD })
      }
    }

    if (formData.lot.length === 0) {
      success()
    } else {
      // FAZ A COMUNICAÇÃO COM A API
      $store.state.comunicaAPI('/arm-arquivo/upl-finalizar', 'PUT', formData, function (apiSuccess) {
        for (var indexD in formData.lot) {
          // PEGA A CHAVE DO VETOR
          var indexF = formData.lot[indexD].chave
          
          // VERIFICA SE O RETORNO RECEBIDO FOI DE SUCESSO
          switch (apiSuccess.lot[indexD].code) {
            case '200':
              // SETA A CREDENCIAL RECEBIDA
              retornos[indexF].code = '200'
              retornos[indexF].message = 'Upload realizado com sucesso.'
              break

            default:
              // SETA O RETORNO RECEBIDO DA API
              retornos[indexF].code = apiSuccess.lot[indexD].code
              retornos[indexF].message = apiSuccess.lot[indexD].message

              // VERIFICA SE DEVE CONVERTE A MENSAGEM DE ARRAY PARA STRING
              retornos[indexF].message = typeof retornos[indexF].message === 'object' ? retornos[indexF].message.join(' ') : retornos[indexF].message
              break
          }
        }

        // PASSA O STATUS DO PROCESSO
        progress('Finalizando.')

        // RETORNA O VALOR ATUALIZADO
        success(retornos)
      }, error)
    }
  }
}
